export const getObjectValueByKey = (path: string, obj?: any) =>
  !obj ||
  path
    .replace(/\[|\]\.?/g, '.')
    .split('.')
    .filter((s) => s)
    .reduce((acc, val) => acc && acc[val], obj)
